import { Frequency } from '../types/municipalityData'

/**
 * En vald insats är ifylld när både nivå och frekvens är valda (#79). Undantaget är övriga insatser
 * som saknar frekvenser i inställningarna – de räknas per månad och där räcker nivån. Tidpunktsinsatser
 * kräver alltid båda.
 *
 * Uträkningen, sammanställningen och Ofullständig inmatning använder samma regel, så att bara ifyllda
 * insatser räknas och visas och alla andra varnas för.
 */
export const isTaskComplete = (taskType: 'timepoint' | 'other', level: string | null | undefined, frequency: number | null | undefined, frequencies?: Frequency[]) => {
  if (!level || level === '-') return false
  if (frequency) return true
  return taskType === 'other' && !frequencies?.length
}
